export default class GroupingPackageDetail {
    packageId: number;
    packageCode: string;
    soCode: string;
    externalCode:string;
    aoGroupCode:string;
    customerName: string;
    shippingFullAddress:string;
    customerPhone:string;
    tplCode:string;
    creatorUserId:number;
    creatorUserName:string;
}